import { render, staticRenderFns } from "./UsersNewUser.vue?vue&type=template&id=216edb5c"
import script from "./UsersNewUser.vue?vue&type=script&lang=js"
export * from "./UsersNewUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports